<template>
    <div class="title-image">
        <div class="title-image-body" v-for="(item, index) in titleImageData" :key="index">
            <div class="title">{{ $t(item.title) }}</div>
            <div class="img">
                <img :src="item.imgUrl" alt="" />
            </div>
            <div v-if="item.followPc" class="followPc" v-html="$t(item.followPc)"></div>
            <div v-if="item.followMobile" class="followMobile">
                {{ $t(item.followMobile) }}
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import imgUrl1 from '@assets/imgs/Solutions/Brand/Swipper/brandUrl1.png';
    import imgUrl2 from '@assets/imgs/Solutions/Brand/Swipper/brandUrl2.png';
    import imgUrl3 from '@assets/imgs/Solutions/Brand/Swipper/brandUrl3.png';
    import brandUrlEN1 from '@assets/imgs/Solutions/Brand/Swipper/brandUrlEN1.png';
    import brandUrlEN2 from '@assets/imgs/Solutions/Brand/Swipper/brandUrlEN2.png';
    import brandUrlEN3 from '@assets/imgs/Solutions/Brand/Swipper/brandUrlEN3.png';
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    import { ref, onMounted, onBeforeMount, computed } from 'vue';
    import { ifCNLocale } from '~~/composables/useLocale.ts';

    const isCN = ifCNLocale();
    const isMobile = ref(false);

    const titleImageData = [
        {
            title: 'global_solutions_brand_titleimage_1',
            imgUrl: isCN ? imgUrl1 : brandUrlEN1,
        },
        {
            title: 'global_solutions_brand_titleimage_2',
            imgUrl: isCN ? imgUrl2 : brandUrlEN2,
            followPc: 'global_solutions_brand_followimage_2',
            followMobile: 'global_solutions_brand_followimage_moblie_2',
        },
        {
            title: 'global_solutions_brand_titleimage_3',
            imgUrl: isCN ? imgUrl3 : brandUrlEN3,
        },
    ];

    onMounted(() => {
        isMobile.value = matchMobile();
    });
</script>

<style lang="less" scoped>
    .title-image {
        font-family: 'HarmonyOS Sans SC';
        &-body {
            display: flex;
            flex-direction: column;
            align-items: center;
            .title {
                text-align: center;
                font-size: .convert(@font-size-title-xs) [ @vw]; //36px
                line-height: 100%;
                margin: .convert(100px) [ @vw] 0 .convert(40px) [ @vw] 0;

                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(@font-size-lg) [ @vw-mobile] !important; //20px
                    margin: .convert(34px) [ @vw-mobile] 0 .convert(12px) [ @vw-mobile] 0;
                }
            }
            .img {
                width: 100%;
                display: flex;
                justify-content: center;
                img {
                    width: .convert(1200px) [ @vw];
                    @media (max-width: @screen-mobile-width) {
                        width: 100%;
                    }
                }
            }
            .followPc {
                width: .convert(1125px) [ @vw];
                margin-top: .convert(24px) [ @vw];
                color: #d9d9d9;
                text-align: center;
                font-size: .convert(20px) [ @vw];
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                @media (max-width: @screen-mobile-width) {
                    margin-top: .convert(24px) [ @vw-mobile];
                    display: none;
                }
            }
            .followMobile {
                display: none;

                @media (max-width: @screen-mobile-width) {
                    margin-top: .convert(11px) [ @vw-mobile];
                    display: block;
                }
            }
        }
    }
    :lang(en) {
        .title-image {
            font-family: Montserrat;
        }
    }
</style>
